
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import CustomFieldMixin from '@/mixins/CustomFieldMixin';

@Component
export default class FileInputField extends mixins(CustomFieldMixin) {
  get defaultAttributes() {
    return {
      prependIcon: '',
      prependInnerIcon: 'mdi-attachment',
      placeholder: 'Select file...',
    };
  }
}
